import {
  SET_ACTIVE_ROOM_CLASS,
  RESET_ACTIVE_ROOM_CLASS,
} from '../actions/setActiveRoomClassActions';

const initialState = {};

export default function activeRoomClassReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_ROOM_CLASS:
      return { ...state, roomClassificationCodes: action.payload };
    case RESET_ACTIVE_ROOM_CLASS:
      return { ...state, roomClassificationCodes: {}};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activeRoomClassReducers.js